module.exports = __webpack_public_path__ + "d4b5605d69641f20cff53ddefc51f33f.png";